import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PortalSetPasswordForm } from '@/components/portal/PortalSetPasswordForm';
import { usePortalResetPassword } from '@/hooks/portal/usePortalAuth';

export const Route = createFileRoute('/(portal)/portal/reset')({
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({
    token: typeof s.token === 'string' ? s.token : undefined,
  }),
  component: PortalResetPage,
});

function PortalResetPage() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  const reset = usePortalResetPassword();

  return (
    <PortalSetPasswordForm
      title="Set a new password"
      description="Choose a new password for your portal account."
      submitLabel="Update password"
      token={token}
      pending={reset.isPending}
      onSubmit={async (password) => {
        await reset.mutateAsync({ token: token!, password });
        await navigate({ to: '/portal' });
      }}
    />
  );
}
